import { useState } from 'react';
import { Layout, CtaForm, MailForm, Popup } from '../../components';
import { ROI_METHODOLOGY_LINK } from '../../constants';
import { handleCalculateROI } from '../../utils';

export default function ROICalculator() {
	return (
		<Layout pageName="ROI Calculator">
			<div className="resource-page resource-page--roi-calculator">
				<section className="heading-container">
					<div className="container">
						<div className="heading heading--resources">
							<h1 className="heading__title">Get immediate return on your investment</h1>
							<h2 className="heading__desc">
								Digitization and automation are known to be good investments. Find out how valuable{' '}
								<span>Facility</span>
								<b>Bot</b> can be to your Facility.
							</h2>
						</div>
					</div>
				</section>

				<section className="calculator">
					<div className="container">
						<div className="calculator-wrapper">
							<h3 className="calculator__title">Calculate Your Savings</h3>

							<CalculatorForm />
						</div>
					</div>
				</section>

				<CtaForm />
			</div>
		</Layout>
	);
}

const CalculatorForm = () => {
	const [teamSize, setTeamSize] = useState(0);
	const [hourlyRate, setHourlyRate] = useState(0);
	const [visible, setVisible] = useState(false);

	function handleSubmit(e) {
		e.preventDefault();
		setVisible(true);
	}

	return (
		<form className="calculator__form" onSubmit={handleSubmit}>
			<div className="calculator__form-field">
				<label htmlFor="team-size">How many people are there in your maintenance team?</label>

				<input
					type="number"
					id="team-size"
					required
					autoFocus
					placeholder="# of people"
					onChange={(e) => setTeamSize(e.target.value)}
				/>
			</div>

			<div className="calculator__form-field">
				<label htmlFor="hourly-rate">
					On average, how much is each member of your maintenance team paid per hour? (SGD)
				</label>

				<input
					type="number"
					id="hourly-rate"
					required
					placeholder="e.g. SGD 20 per hour"
					onChange={(e) => setHourlyRate(e.target.value)}
				/>
			</div>

			<div className="calculator__form-field">
				<button type="submit" className="btn calculator__submit-btn">
					Calculate
				</button>

				<Popup visible={visible} onCancel={() => setVisible(!visible)}>
					<div className="result">
						<div className="result__main">
							<h2 className="result__main-title">
								<span>Facility</span>Bot can save you up to
							</h2>
							<h4 className="result__main-saving">SGD {handleCalculateROI(teamSize, hourlyRate)}</h4>
							<h2 className="result__main-annual">per year</h2>
						</div>

						<div className="result__cta">
							<MailForm />
						</div>

						<div className="result__footer">
							Wondering how we arrive at the savings calculation. Find out our methodology{' '}
							<a href={ROI_METHODOLOGY_LINK} target="_blank" rel="noreferrer">
								here
							</a>
						</div>
					</div>
				</Popup>
			</div>

			<div className="calculator__form-field">
				<span className="calculator__roi-methodology">
					Wondering how we arrive at the savings calculation. Find out our methodology{' '}
					<a href={ROI_METHODOLOGY_LINK} target="_blank" rel="noreferrer">
						here
					</a>
				</span>
			</div>
		</form>
	);
};
